import PropTypes from 'prop-types'
import React from 'react'

const sizeClass = {
  sm: 'brand-logo--sm',
  md: '',
  lg: 'brand-logo--lg',
  auth: 'brand-logo--auth'
}

const BrandWordmark = ({ className = '', size = 'md' }) => (
  <span className={`brand-logo ${sizeClass[size] || ''} ${className}`.trim()}>ZAP+</span>
)

BrandWordmark.propTypes = {
  className: PropTypes.string,
  size: PropTypes.oneOf(['sm', 'md', 'lg', 'auth'])
}

export default BrandWordmark
